export const PROFILE = 'profile';
export const TOKEN = 'token';
export const FIREBASE_TOKEN = 'firebase_token';
export const REFRESH_TOKEN = 'refresh_token';



// WEBPACK FOOTER //
// ./src/js/config/constants/auth-keys.js